export default __webpack_public_path__ + "static/media/preview.0d2a6958.png";